import { plannerPages } from "settings/menu/plannerPages";

export const defaultNotSelectedClient = "All Clients";
export const nonSideMenuItems = [...plannerPages?.items]; //[adminConsole];
